(function () {
  'use strict';

  var selector = '.template-product .has-link-more > .link-more, #quickshop .has-link-more > .link-more';
  var openClass = 'orbitopia-read-more-open';
  var nextId = 0;

  function findToggle(target) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function findContent(toggle) {
    var linkRow = toggle ? toggle.closest('.has-link-more') : null;
    if (!linkRow) return null;
    var content = linkRow.previousElementSibling;
    if (content && content.classList.contains('m6lm')) return content;
    return linkRow.parentElement ? linkRow.parentElement.querySelector('.m6lm') : null;
  }

  function setState(toggle, content, expanded) {
    content.classList.toggle(openClass, expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var labels = toggle.querySelectorAll('span');
    if (labels.length > 1) {
      labels[0].classList.toggle('hidden', expanded);
      labels[1].classList.toggle('hidden', !expanded);
    }
  }

  function prepare(toggle) {
    var content = findContent(toggle);
    if (!content) return null;
    if (!content.id) {
      nextId += 1;
      content.id = 'orbitopia-product-description-' + nextId;
    }
    toggle.setAttribute('role', 'button');
    toggle.setAttribute('aria-controls', content.id);
    if (!toggle.hasAttribute('aria-expanded')) setState(toggle, content, false);
    return content;
  }

  function prepareAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(selector), prepare);
  }

  if (!document.getElementById('orbitopia-product-read-more-style')) {
    var style = document.createElement('style');
    style.id = 'orbitopia-product-read-more-style';
    style.textContent =
      '.template-product .has-link-more,#quickshop .has-link-more{position:relative;z-index:3}' +
      '.template-product .has-link-more>.link-more,#quickshop .has-link-more>.link-more{position:relative!important;z-index:4!important;pointer-events:auto!important;cursor:pointer!important;touch-action:manipulation}' +
      '.template-product .m6lm.' + openClass + ',#quickshop .m6lm.' + openClass + '{display:block!important;height:auto!important;max-height:none!important;overflow:visible!important;-webkit-line-clamp:unset!important;line-clamp:unset!important;-webkit-mask-image:none!important;mask-image:none!important}' +
      '.template-product .m6lm.' + openClass + '::after,#quickshop .m6lm.' + openClass + '::after{display:none!important}' +
      '.template-product .link-more[aria-expanded="true"] .icon-chevron-down,#quickshop .link-more[aria-expanded="true"] .icon-chevron-down{transform:rotate(180deg);transition:transform .2s ease}';
    document.head.appendChild(style);
  }

  document.addEventListener('click', function (event) {
    var toggle = findToggle(event.target);
    if (!toggle) return;
    var content = prepare(toggle);
    if (!content) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setState(toggle, content, toggle.getAttribute('aria-expanded') !== 'true');
  }, true);

  document.addEventListener('keydown', function (event) {
    var toggle = findToggle(event.target);
    if (!toggle || (event.key !== ' ' && event.key !== 'Spacebar')) return;
    var content = prepare(toggle);
    if (!content) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setState(toggle, content, toggle.getAttribute('aria-expanded') !== 'true');
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { prepareAll(document); });
  } else {
    prepareAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { prepareAll(event.target); });
}());
